import { render, staticRenderFns } from "./supervisioralert.vue?vue&type=template&id=653f0f60"
import script from "./supervisioralert.js?vue&type=script&lang=js&external"
export * from "./supervisioralert.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports